import { useEffect, useState } from 'react'
export type ImageMeta = {
  state?: false | 'error' | 'loaded'
  size?: {
    width: number
    height: number
  }
}

export function useImageLoaded({
  src,
  srcSet
}: {
  src?: string
  srcSet?: string
}): ImageMeta {
  const [loaded, setLoaded] = useState<ImageMeta>({})

  useEffect(() => {
    let active = false
    if (src) {
      setLoaded({
        state: false
      })
      active = true

      const image = new Image()
      image.src = src
      if (srcSet) {
        image.srcset = srcSet
      }
      image.onload = () => {
        if (active) {
          setLoaded({
            state: 'loaded',
            size: {
              width: image.width,
              height: image.height
            }
          })
        }
      }
      image.onerror = () => {
        if (active) {
          setLoaded({
            state: 'error'
          })
        }
      }
    }
    return () => {
      active = false
    }
  }, [src, srcSet])

  return loaded
}
